interface SegmentedControlProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

export function SegmentedControl<T extends string>({ options, value, onChange }: SegmentedControlProps<T>) {
  return (
    <div className="flex p-1 rounded-xl bg-black/[0.06] dark:bg-white/10 w-full">
      {options?.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`flex-1 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${
            value === opt.value
              ? 'bg-white dark:bg-white/20 shadow text-current'
              : 'text-black/50 dark:text-white/50 hover:text-current'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
